import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
  fontFamily: '"Nanum Barun Gothic", sans-serif'
};

export const themeV1: DefaultTheme = {
  fontFamily: '"Noto Sans KR", sans-serif'
};

export const themeV2: DefaultTheme = {
  fontFamily: '"Pretendard", sans-serif'
};

